import React from 'react';
import { Tooltip } from "antd";
import { useAuth } from "../../providers/AuthProvider";

/**
 * A quiet "Booked" flag for talent who are fully booked.
 *
 * Fully booked talent are excluded from position matches by default, and only
 * Wripple staff can opt them back in — so the flag is staff-only too. Clients
 * never see it, and available talent get nothing at all: the absence of the
 * flag *is* the "available" state, which keeps every other tile unchanged.
 *
 * Sized to sit inline beside the location line without changing its height,
 * so a booked tile stays aligned with the tiles around it.
 */
const TalentBookedIndicator = ({ talent, className = '' }) => {
    const { auth } = useAuth();

    if (!talent?.is_fully_booked || !auth?.canManageClients?.()) {
        return null;
    }

    return (
        <Tooltip
            placement="top"
            color="#000"
            title={`${talent.firstNamePlusInitial?.() || 'This talent'} is fully booked and not currently available for new work. Visible to Wripple staff only.`}
        >
            <span
                className={`inline-flex shrink-0 cursor-default select-none items-center gap-1 rounded-full bg-[#FEF3E2] py-[2px] pl-[6px] pr-[7px] text-[10.5px] font-semibold leading-none text-[#B45309] ring-1 ring-inset ring-[#F9DDB0] ${className}`}
            >
                <span className="h-[5px] w-[5px] rounded-full bg-[#F59E0B]" aria-hidden="true" />
                Booked
            </span>
        </Tooltip>
    );
};

export default TalentBookedIndicator;
